export const SpacerArray = [
    '0',
    '0.8rem',
    '1.6rem',
    '2.4rem',
    '3.2rem',
    '4.0rem',
    '4.8rem',
    '5.6rem',
    '6.4rem',
    '7.2rem',
    '8.0rem',
];
